import { render } from "./ForgotPasswordForm.vue?vue&type=template&id=5902c212"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
script.render = render

export default script